module.exports = __webpack_public_path__ + "img/programme2.8eb91d04.png";